module.exports = __webpack_public_path__ + "static/media/project-icon-goals1.6fc90725.png";